import { ERequestFormField } from '../requestFormSchema';

export enum ESpecialFlowValidationErrorCodes {
  AddressNotFound = 'addressNotFound',
  AddressHasManyCadastre = 'addressHasManyCadastre',
  CadastreNotFound = 'cadastreNotFound',
}

export interface IRequestFormValidationError {
  key: ERequestFormField | string;
  code: ESpecialFlowValidationErrorCodes | string;
  message: string;
}
